var Observable_1 = require('../../Observable');
var never_1 = require('../../observable/never');
Observable_1.Observable.never = never_1.InfiniteObservable.create;
//# sourceMappingURL=never.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/observable/never.js
 ** module id = 320
 ** module chunks = 1
 **/